import React from "react";
import { Modal } from "antd";
import { FaTimes } from "react-icons/fa";

const ImageUploadSection = ({
  getRootProps,
  getInputProps,
  fileList,
  mainImage,
  previewOpen,
  previewImage,
  previewTitle,
  handlePreview,
  handleRemove,
  handleMainImageChange,
  handleCancel,
  uploadButton,
  t,
}) => {
  return (
    <div className='flex flex-wrap justify-center'>
      <div
        {...getRootProps({ className: "dropzone" })}
        className='border-2 border-dashed border-gray-300 hover:border-cromboOrange hover:text-cromboOrange p-5 text-center w-48 h-48 flex items-center justify-center m-2'>
        <input {...getInputProps()} />
        {uploadButton}
      </div>

      {fileList.map((file) => (
        <div key={file.uid} className='relative m-2'>
          <img
            src={file.url}
            alt={file.name}
            className='w-48 h-48 object-cover cursor-pointer'
            onClick={() => handlePreview(file)}
          />
          <button
            onClick={() => handleRemove(file)}
            className='absolute top-2 right-2 bg-white p-1 rounded-md shadow-md'>
            <FaTimes className='text-red-500' />
          </button>
          <div className='absolute bottom-0 w-full bg-black/50 px-2 py-1 text-white shadow-md'>
            <input
              type='checkbox'
              checked={mainImage === file.url}
              onChange={() => handleMainImageChange(file.url)}
              className='text-cromboOrange'
            />
            <label className='ml-1 text-sm'>{t("admin:mainImage")}</label>
          </div>
        </div>
      ))}

      <Modal
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}>
        <img className='w-full' src={previewImage} alt={previewTitle} />
      </Modal>
    </div>
  );
};

export default ImageUploadSection;
